export { Hero } from './Hero/Hero';

export { ImageTextBanner } from './imageTextBanner';

export { BannerSwitcher } from './BannerSwitcher/BannerSwitcher';

// Right Text Banner
export {
  ImageRightTextMediumBanner,
  HomeSliderBanner,
} from './RightText/imageRightTextBanner';

// BlackFriday 2022
export { BlackFridayHero } from './BlackFriday/BlackFriday';

// Left Text Banner
export {
  ImageLeftTextMediumBanner,
  ImageLeftTextSlimBanner,
  ImageLeftTextFaceHighLightBanner,
  CrmFormBanner,
} from './LeftText/imageLeftTextBanner';

// Center Text Banner
export { ImageCenterTextMediumBanner } from './CenterText/imageCenterTextBanner';
export { TextWithLineBanner } from './BannerText/bannerText';

export { BannerButtons, Buttons } from './BannerButtons/bannerButtons';
